import { Locale } from '../../enums/locale'
import intlBeheard from './intlBeheard'
import intlBeseen from './intlBeseen'
import intlComponents from './intlComponents'
import intlGeneral from './intlGeneral'

export default {
  [Locale.EUSpanish]: {
    ...intlGeneral,
    ...intlBeheard,
    ...intlBeseen,
    ...intlComponents,
  },
}